<template>
  <q-layout view="lHh Lpr lFf" class="fit">
    <q-page-container class="fit">
      <router-view></router-view>
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from "vue";
export default {
  name: "LayoutDefault",
  components: {},
  setup() {
    return {
      leftDrawerOpen: ref(false),
    };
  },
};
</script>
<style lang="scss">
* {
  /* Normaliza renderização entre navegadores e SOs */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}

html {
  /* Previne zoom automático em Windows com DPI alto */
  zoom: 1;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  /* Tamanho base fixo para manter consistência */
  font-size: 16px;
  /* Altura mínima para evitar problemas em resoluções baixas */
  min-height: 100vh;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
  min-height: 100vh;
  /* Previne seleção acidental que pode causar zoom em mobile */
  -webkit-touch-callout: none;
}

#app {
  border-style: none !important;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Previne zoom em inputs em iOS/Safari */
input,
select,
textarea,
button {
  font-size: 16px !important;
}

.section-title:after {
  content: "";
  border: 2px solid goldenrod;
  width: 82px;
  display: block;
  margin-top: 5px;
}
</style>
